var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-header":"","hide-footer":"","body-class":"p-0","modal-class":"modal-full-height","no-close-on-esc":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('post-photo-actions'),_c('post-photo-gallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }